export const PREVIEW_ACCOUNT_MESSAGE =
  'This is a preview account: publishing and provider actions are off.';

export const PREVIEW_ACCOUNT_CODE = 'preview_account';

export const PREVIEW_ACCOUNT_PLAN_LABEL = 'Complimentary preview plan';

export const PREVIEW_REFUSED_PAID_ACTIONS: readonly string[] = [
  'prepare_execution_v3',
  'confirm_execution_v3',
  'retry_execution_v3',
  'reconcile_execution_v3',
  'prepare_activation_v3',
  'confirm_activation_v3',
  'prepare_pause_v3',
  'confirm_pause_v3',
  'prepare_pause_ad_v3',
  'confirm_pause_ad_v3',
  'prepare_paused_settings_update_v3',
  'confirm_paused_settings_update_v3',
  'confirm_google_search',
  'confirm_google_status_transition',
  'reconcile_command',
  'save_draft',
  'save_draft_v2',
  'propose',
  'reopen_draft',
  'discard_draft',
];

export function isPreviewRefusedPaidAction(action: unknown): boolean {
  return typeof action === 'string' && PREVIEW_REFUSED_PAID_ACTIONS.includes(action);
}

const MISSING_FUNCTION_CODES = new Set(['42883', 'PGRST202']);

export function isMissingPreviewFunctionError(error: unknown): boolean {
  const code = (error as { code?: unknown } | null)?.code;
  return typeof code === 'string' && MISSING_FUNCTION_CODES.has(code);
}
